export const SortDirection = {
  ASC: "ASC",
  DESC: "DESC",
};

export const sortByField = (items, getField, sortDirection = SortDirection.ASC) => {
  const sortedList = [...items];
  if (!getField || !sortDirection) {
    return sortedList;
  }

  const isGetFieldFunction = typeof getField === "function";

  return sortedList.sort((leftItem, rightItem) => {
    const left = isGetFieldFunction ? getField(leftItem) : leftItem[getField];
    const right = isGetFieldFunction ? getField(rightItem) : rightItem[getField];
    if (sortDirection === SortDirection.ASC) {
      return left < right ? -1 : 1;
    }
    return left > right ? -1 : 1;
  });
};

export const arraymove = (arr, fromIndex, toIndex) => {
  if (fromIndex === -1 || toIndex === fromIndex) {
    return;
  }

  let element = arr[fromIndex];
  arr.splice(fromIndex, 1);
  arr.splice(toIndex, 0, element);
};

export const moveArrayElementToIndex = (items, element, index, key = "") => {
  let indexCurrent;

  if (key) {
    indexCurrent = items.findIndex((i) => i[key] === element);
  } else {
    indexCurrent = items.indexOf(element);
  }

  if (indexCurrent !== -1 && indexCurrent !== index) {
    arraymove(items, indexCurrent, index);
  }

  return items;
};

/**
 * Sort base array based on sort list
 * @param {array} baseList
 * @param {array} sortList
 * @param {string} key
 * @returns sorted array
 */
export const sortByArray = (baseList, sortList, key = "") => {
  const outList = [...baseList];
  const indexList = {};
  sortList.forEach((item, index) => (indexList[item] = index + 1));
  outList.sort((a, b) => {
    const valA = key ? a[key] : a;
    const valB = key ? b[key] : b;
    const orderA = indexList[valA] || outList.length;
    const orderB = indexList[valB] || outList.length;
    return orderA - orderB;
  });
  return outList;
};

export const filterByArray = (arr, arrKeysFilters, key) => {
  if (arrKeysFilters.length === 0) {
    return arr;
  }

  return arr.filter((i) => arrKeysFilters.includes(i[key]));
};

export const toggleInArray = (arr, value, forcePush, forceRemove = false) => {
  const index = arr.indexOf(value);
  if (index === -1) {
    if (!forceRemove) {
      arr.push(value);
    }
  } else if (!forcePush) {
    arr.splice(index, 1);
  }
  return index;
};

export const removeFromArrayWithArray = (array, removeIds) => {
  let removeId, removeIdIndex;
  for (let i = 0; i < removeIds.length; i++) {
    removeId = removeIds[i];

    removeIdIndex = array.findIndex((element) => element === removeId);
    if (removeIdIndex !== -1) {
      array.splice(removeIdIndex, 1);
    }
  }
};

// Converts an ArrayBuffer to base64, by converting to string
// and then using window.btoa' to base64.
export const bufferToBase64 = function (buffer) {
  if (!global.window) {
    return "";
  }

  const bytes = new Uint8Array(buffer);
  const len = buffer.byteLength;
  let binary = "";
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
};

export const arrayToObjMap = (aArray, key, value) => {
  let obj = {};
  aArray.forEach((item) => {
    obj[item[key]] = item[value];
  });
  return obj;
};

export const joinObjArrays = (arrays, key = "id") => {
  let obj = {};

  arrays.forEach((array) => {
    array.forEach((item) => {
      if (!obj[item[key]]) {
        obj[item[key]] = item;
      }
    });
  });

  let finalList = [];

  Object.keys(obj).forEach((objKey) => {
    finalList.push(obj[objKey]);
  });
  return finalList;
};

export const joinArrays = (arrays) => {
  const arrayFull = [];
  arrays.forEach((arr) => {
    arrayFull.push(...arr);
  });
  return [...new Set(arrayFull)];
};

export const isArr1IncludesEachArr2Item = (arr1, arr2) => {
  return arr1 && arr2
    && arr1.length && arr2.length
    && arr2.every((element) => arr1.includes(element));
};

export const isArraysContentsEquals = (arr1, arr2, compareOrder) => {
  return arr1 && arr2
    && arr1.length === arr2.length
    && arr2.every((element, index) => {
      return compareOrder === true ? element === arr1[index] : arr1.includes(element);
    });
};
